export default __webpack_public_path__ + "static/media/665.b99aa9e6.png";